(function () {
  'use strict';

  var HISTORY_KEY = 'apodemia:recently-viewed';
  var MAX_HISTORY = 6;
  var FETCH_LIMIT = 10;
  var GENERIC_COLLECTIONS = {
    'all': true,
    'best-sellers': true,
    'novedades': true,
    'new': true,
    'rebajas': true,
    'sale': true,
    'frontpage': true
  };
  var GENERIC_TAGS = {
    '0': true,
    's': true,
    'm': true,
    'l': true,
    'xs': true,
    'xl': true,
    'ear': true,
    'nec': true,
    'pro': true,
    'pac': true,
    'joyas': true,
    'bienvenida': true,
    'new': true,
    'par': true,
    'unidad': true,
    'oro': true,
    'plata': true,
    'sin talla': true,
    'sin color': true,
    'talla unica': true,
    'no detail': true,
    'no aplica': true,
    'bano de oro 18k': true,
    'bano plata': true,
    'bano oro rosa 18k': true,
    'oro macizo 18k': true
  };
  var TITLE_STOP_WORDS = {
    'a': true,
    'al': true,
    'con': true,
    'de': true,
    'del': true,
    'el': true,
    'en': true,
    'la': true,
    'las': true,
    'los': true,
    'para': true,
    'y': true,
    'anillo': true,
    'anillos': true,
    'cadena': true,
    'cadenas': true,
    'charm': true,
    'collar': true,
    'collares': true,
    'pendiente': true,
    'pendientes': true,
    'pulsera': true,
    'pulseras': true
  };

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  function list(value) {
    return String(value || '')
      .split('|')
      .map(normalize)
      .filter(Boolean);
  }

  function unique(values) {
    return values.filter(function (value, index) {
      return values.indexOf(value) === index;
    });
  }

  function meaningfulTags(values, type) {
    return unique(values.filter(function (tag) {
      if (tag === type || GENERIC_TAGS[tag]) return false;
      if (/^(blackfriday|rebajas|landing-|best_seller|no-50)/.test(tag)) return false;
      return tag.length > 2;
    }));
  }

  function meaningfulCollections(values, fallback) {
    return unique(values.filter(function (handle) {
      return handle !== fallback && !GENERIC_COLLECTIONS[handle];
    }));
  }

  function titleTokens(value) {
    return unique(normalize(value)
      .replace(/[^a-z0-9\s]/g, ' ')
      .split(/\s+/)
      .filter(function (word) {
        return word.length > 2 && !TITLE_STOP_WORDS[word];
      }));
  }

  function intersectionCount(a, b) {
    return a.filter(function (value) { return b.indexOf(value) !== -1; }).length;
  }

  function metadata(node, fallback) {
    var type = normalize(node.getAttribute('data-product-type'));
    return {
      node: node,
      id: node.getAttribute('data-product-id') || '',
      handle: normalize(node.getAttribute('data-product-handle')),
      type: type,
      title: titleTokens(node.getAttribute('data-product-title')),
      price: parseInt(node.getAttribute('data-product-price') || '0', 10),
      tags: meaningfulTags(list(node.getAttribute('data-product-tags')), type),
      collections: meaningfulCollections(list(node.getAttribute('data-product-collections')), fallback),
      finish: normalize(node.getAttribute('data-product-finish')),
      available: node.getAttribute('data-product-available') !== 'false'
    };
  }

  function currentMetadata(root, fallback) {
    var type = normalize(root.getAttribute('data-product-type'));
    return {
      id: root.getAttribute('data-product-id') || '',
      handle: normalize(root.getAttribute('data-product-handle')),
      type: type,
      title: titleTokens(root.getAttribute('data-product-title')),
      price: parseInt(root.getAttribute('data-product-price') || '0', 10),
      tags: meaningfulTags(list(root.getAttribute('data-product-tags')), type),
      collections: meaningfulCollections(list(root.getAttribute('data-product-collections')), fallback),
      finish: normalize(root.getAttribute('data-product-finish'))
    };
  }

  function priceAffinity(a, b) {
    if (!a || !b) return 0;
    var ratio = Math.min(a, b) / Math.max(a, b);
    if (ratio >= 0.8) return 24;
    if (ratio >= 0.6) return 14;
    if (ratio >= 0.4) return 6;
    return 0;
  }

  function relatedScore(item, current) {
    if (!item.available || item.id === current.id || item.handle === current.handle) {
      return { qualifies: false, score: -1 };
    }
    if (item.type === 'packaging regalo' || item.type === 'promotional gift') {
      return { qualifies: false, score: -1 };
    }
    if (item.tags.indexOf('no-recomendado') !== -1) {
      return { qualifies: false, score: -1 };
    }

    var sameType = item.type && item.type === current.type;
    var sharedCollections = intersectionCount(item.collections, current.collections);
    var sharedTags = intersectionCount(item.tags, current.tags);
    var sharedTitle = intersectionCount(item.title, current.title);
    var sameFinish = item.finish && item.finish === current.finish;
    var score = priceAffinity(item.price, current.price);

    if (sameType) score += 140;
    score += Math.min(sharedCollections, 2) * 80;
    score += Math.min(sharedTags, 3) * 28;
    score += Math.min(sharedTitle, 2) * 60;
    if (sameFinish) score += 18;

    return {
      qualifies: Boolean(sameType || sharedCollections || sharedTags || sharedTitle),
      score: score
    };
  }

  function historyScore(item, history) {
    var score = 0;
    history.forEach(function (viewed, index) {
      var weight = Math.max(1, MAX_HISTORY - index);
      if (item.type && item.type === viewed.type) score += 18 * weight;
      score += intersectionCount(item.collections, viewed.collections) * 10 * weight;
      score += Math.min(intersectionCount(item.tags, viewed.tags), 2) * 7 * weight;
      score += Math.min(intersectionCount(item.title, viewed.title), 1) * 12 * weight;
      if (item.finish && item.finish === viewed.finish) score += 3 * weight;
      score += Math.round(priceAffinity(item.price, viewed.price) * weight / 8);
    });
    return score;
  }

  function readHistory(currentHandle) {
    try {
      var stored = JSON.parse(localStorage.getItem(HISTORY_KEY));
      if (!Array.isArray(stored)) return [];
      return unique(stored.map(normalize).filter(function (handle) {
        return handle && handle !== currentHandle;
      })).slice(0, MAX_HISTORY);
    } catch (error) {
      return [];
    }
  }

  function sectionItems(html, expectedSource, fallback) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var section = doc.querySelector('[data-product-carousel]');
    if (!section || section.getAttribute('data-source') !== expectedSource) return [];
    return Array.prototype.map.call(section.querySelectorAll('[data-recommendation-item]'), function (node) {
      return metadata(node, fallback);
    });
  }

  function fetchItems(url, source, fallback) {
    return fetch(url)
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject(response.status);
      })
      .then(function (html) {
        return sectionItems(html, source, fallback);
      });
  }

  function relatedItems(root, fallback) {
    var url =
      (root.getAttribute('data-recommendations-url') || '/recommendations/products') +
      '?section_id=' + encodeURIComponent(root.getAttribute('data-section-id')) +
      '&product_id=' + encodeURIComponent(root.getAttribute('data-product-id')) +
      '&limit=' + FETCH_LIMIT +
      '&intent=related';
    return fetchItems(url, 'recommendations', fallback);
  }

  function historyItems(root, handles, fallback) {
    if (!handles.length) return Promise.resolve([]);
    var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var query = handles.map(function (handle) { return 'handle:' + handle; }).join(' OR ');
    var url =
      rootUrl + 'search?section_id=' + encodeURIComponent(root.getAttribute('data-section-id')) +
      '&type=product&options[unavailable_products]=last&q=' + encodeURIComponent(query);
    return fetchItems(url, 'search', fallback).then(function (items) {
      var byHandle = {};
      items.forEach(function (item) { byHandle[item.handle] = item; });
      return handles.map(function (handle) { return byHandle[handle]; }).filter(Boolean);
    });
  }

  function sortByScore(items, scoreFn) {
    return items.map(function (item, index) {
      return { item: item, score: scoreFn(item), index: index };
    }).sort(function (a, b) {
      return b.score - a.score || a.index - b.index;
    }).map(function (entry) {
      entry.item.rankScore = entry.score;
      return entry.item;
    });
  }

  function initCarousel(root) {
    var productId = root.getAttribute('data-product-id');
    if (!productId || root.hasAttribute('data-recs-loaded')) return;
    root.setAttribute('data-recs-loaded', '');
    root.setAttribute('aria-busy', 'true');

    var fallback = normalize(root.getAttribute('data-fallback-collection'));
    var current = currentMetadata(root, fallback);
    var limit = parseInt(root.getAttribute('data-limit') || '8', 10);
    var initialSource = root.getAttribute('data-source');
    var initialItems = Array.prototype.map.call(root.querySelectorAll('[data-recommendation-item]'), function (node) {
      return metadata(node.cloneNode(true), fallback);
    });
    var historyHandles = readHistory(current.handle);

    Promise.all([
      relatedItems(root, fallback).catch(function () { return []; }),
      historyItems(root, historyHandles, fallback).catch(function () { return []; })
    ]).then(function (groups) {
        var related = groups[0];
        var history = groups[1];
        var historySet = {};
        historyHandles.forEach(function (handle) { historySet[handle] = true; });

        var currentRelated = sortByScore(related.filter(function (item) {
          return relatedScore(item, current).qualifies;
        }), function (item) {
          return relatedScore(item, current).score;
        });

        if (initialSource === 'manual') {
          currentRelated = initialItems.concat(currentRelated);
        }

        var pool = related.concat(initialItems).filter(function (item) {
          return item.available && !historySet[item.handle];
        });
        var personalized = history.length ? sortByScore(pool, function (item) {
          return historyScore(item, history);
        }).filter(function (item) {
          return item.rankScore >= 45;
        }) : [];
        var categoryBest = sortByScore(initialItems.filter(function (item) {
          return relatedScore(item, current).qualifies;
        }), function (item) {
          return relatedScore(item, current).score;
        });

        var selected = [];
        var seen = {};
        seen[current.id] = true;
        seen[current.handle] = true;

        function add(items, origin) {
          items.forEach(function (item) {
            if (selected.length >= limit || !item.available || historySet[item.handle]) return;
            var key = item.id || item.handle;
            if (!key || seen[key] || seen[item.handle]) return;
            seen[key] = true;
            if (item.handle) seen[item.handle] = true;
            item.node.setAttribute('data-recommendation-origin', origin);
            selected.push(item.node);
          });
        }

        add(currentRelated, 'related');
        add(personalized, 'history');
        add(categoryBest, 'category-bestseller');
        add(initialItems, 'general-bestseller');

        if (selected.length) {
          var track = root.querySelector('[data-carousel-track]');
          track.innerHTML = '';
          selected.forEach(function (node) { track.appendChild(node); });
          track.scrollLeft = 0;
          root.setAttribute('data-recommendation-strategy', 'hybrid');
        }
        root.setAttribute('data-recs-loaded', '');
      })
      .finally(function () {
        root.removeAttribute('aria-busy');
      });
  }

  function initAll() {
    document.querySelectorAll('[data-product-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-product-carousel]');
    if (root) initCarousel(root);
  });
})();
